<script setup>
import en from '@/components/miscellaneous/privacy-policy/en.vue'
import nb from '@/components/miscellaneous/privacy-policy/nb.vue'

definePageMeta({
    layout: 'content-pages'
})
</script>
<template>
    <component :is="$i18n.locale === 'en' ? en : nb"></component>
</template>
